import { useTranslation } from "react-i18next";

import { useTherapist } from "../../../../context/useTherapist";
import { useCenter, useCenterMembers } from "../../../center";
import CenterAdminShell from "../components/CenterAdminShell";
import CenterInvitationsCard from "../components/CenterInvitationsCard";
import CenterTeamCard from "../components/CenterTeamCard";

/**
 * The people in the centre: who works here, and who has been asked to.
 *
 * Its own tab so the summary can stay about the centre itself. Inviting and
 * letting somebody go both start here.
 */
export default function CenterTeamPage() {
    const { t } = useTranslation();
    const { center, loading } = useCenter();
    const { members, loading: membersLoading } = useCenterMembers(center?.id);
    const { therapist } = useTherapist();

    if (loading) {
        return <p className="p-6 text-sm text-gray-500">{t("common.loading")}</p>;
    }

    if (!center) {
        return <p className="p-6 text-sm text-gray-500">{t("center.notFound")}</p>;
    }

    return (
        <CenterAdminShell center={center}>
            <CenterTeamCard
                currentTherapistId={therapist?.id}
                members={members}
                loading={membersLoading}
                type={center.type}
                centerId={center.id}
            />
            <CenterInvitationsCard centerId={center.id} type={center.type} />
        </CenterAdminShell>
    );
}
